<template>
  <el-card class="box-card" shadow='never' :disabled='disabled' :class="{ 'list-disabled': disabled }">
    <div class="content">
      <div class="tab-tages">
        <el-tag class="tag-info" v-for="item in listData" :key="item.id">
          {{ item.label }}
        </el-tag>

      </div>
      <div class="bars" @click="xx" :class="{ 'list-click-disabled': disabled }">
        <i class="el-icon-arrow-down bar-icon"></i>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: ['listData', 'disabled'],
  methods: {
    xx() {
      this.$emit('click')
    }
  }
}
</script>


<style scoped>
.tab-tages .tag-info {
  background-color: #f4f4f5;
  border-color: #e9e9eb;
  color: #909399;
  margin: 2px 0 2px 6px;
  height: 24px;
  padding: 0 8px;
  line-height: 22px;
  float: left;
}

.list-disabled {
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #C0C4CC;
  cursor: not-allowed;
}

.list-click-disabled {
  pointer-events: none;
}

.box-card /deep/ .el-card__body {
  padding: 2px;
}

.content {
  display: flex;

}

.tab-tages {
  position: relative;
  flex-grow: 4;
  min-height: 28px;
  max-height: 280px;
  overflow: auto;

}

.bars {
  position: relative;
  width: 25px;
  flex-grow: 0;
  flex-shrink: 0;
  cursor: pointer;
  color: #C0C4CC;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box-card {
  width: 100%;
  position: relative;
}

/*滚动条的宽度*/

::-webkit-scrollbar {
  width: 6px;
  height: 9px;
}

/*外层轨道。可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果*/

::-webkit-scrollbar-track {
  width: 6px;
  background-color: #e9e9eb;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

/*滚动条的设置*/

::-webkit-scrollbar-thumb {
  background-clip: padding-box;
  background-color: #aaaaaa;
  min-height: 28px;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

/*滚动条移上去的背景*/

::-webkit-scrollbar-thumb:hover {
  background-color: #fff;
}
</style>